import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { useFormatValue } from '../../hooks/useFormatValue'
import { useScreenTypeContext } from '../../state/screenTypeProvider'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'
import { DisplayLabel } from '../subComponents/displayLabel'

interface IFlightHeaderProps {
    flightNumber: string
    label: string
    labelTime?: string
    visibility?: string
    departure?: string
}
export const FlightHeader = ({
    flightNumber,
    label,
    labelTime,
    visibility,
    departure,
}: IFlightHeaderProps) => {
    const { past } = useObjectContext()
    const { formatValue } = useFormatValue()
    const { screenType } = useScreenTypeContext()
    const upNext = screenType === 'upNext' ? true : false
    const icon = useMemo(() => {
        if (label?.includes('Arrival')) return 'Arrive'
        return 'Depart'
    }, [label])

    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={'8px'}>
                <Icon
                    name={icon as any}
                    iconColour={
                        past
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                />
                <CardText variant="bodyBold">{flightNumber}</CardText>
            </Stack>
            <Stack
                alignItems={'center'}
                direction={'row'}
                justifyContent={'flex-start'}
                gap={'8px'}
            >
                {visibility === 'Private' ? (
                    <Icon
                        height={'16px'}
                        width={'16px'}
                        name={'Private'}
                        iconColour={
                            past
                                ? ColoursObj.shades.shade2
                                : ColoursObj.core.secondary
                        }
                    />
                ) : (
                    visibility === 'Public' && (
                        <Icon
                            height={'16px'}
                            width={'16px'}
                            name={'Public'}
                            iconColour={
                                past
                                    ? ColoursObj.shades.shade2
                                    : ColoursObj.core.secondary
                            }
                        />
                    )
                )}
                {upNext ? (
                    <DisplayLabel label={label} labelTime={labelTime} />
                ) : (
                    <CardText variant="bodyBold">
                        {formatValue(departure ?? '', 'date')}
                    </CardText>
                )}
            </Stack>
        </Stack>
    )
}
